import template from './splitView.html';

export const splitViewComponent = {
  name: 'splitViewComponent',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  controller: function($element) {
    'ngInject';

    this.$onInit = function() {
      // Add split class
      $element.addClass('split-view');

      // Set split direction (defaults to )
      switch (this.split) {
        case 'horizontal': {
          this.splitHorizontal = true;
          break;
        }
        case 'vertical': {
          this.splitVertical = true;
          break;
        }
      }

      // Defaults split to vertical
      if (!this.splitHorizontal && !this.splitVertical) {
        this.splitVertical = true;
      }
    };

  },
  bindings: {
    split: '@',
    gutter: '<'
  }
};
